import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Omega 3 vetzuren: waarom zo populair?</title>
                <link rel="canonical" href={route("blogs.sixteenth")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Omega 3 vetzuren worden steeds populairder. Veel suppletie aanbieders hebben deze vorm van meervoudige onverzadigde vetzuren in hun assortiment en elke leefstijlcoach raad je aan om het te supplementeren. Waarom is deze omega 3 vetzuur zo populair en wat het is eigenlijk?"
                />
                <meta
                    property="og:description"
                    content="Omega 3 vetzuren worden steeds populairder. Veel suppletie aanbieders hebben deze vorm van meervoudige onverzadigde vetzuren in hun assortiment en elke leefstijlcoach raad je aan om het te supplementeren. Waarom is deze omega 3 vetzuur zo populair en wat het is eigenlijk?"
                />
                <meta property="og:url" content={route("blogs.sixteenth")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Omega 3 vetzuren: waarom zo populair? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/omega-3-vetzuren.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh]  pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/omega-3-vetzuren.webp"
                                    type="image/webp"
                                    alt="Omega 3 vetzuren"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/omega-3-vetzuren.jpg"
                                    type="image/jpeg"
                                    alt="Omega 3 vetzuren"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/omega-3-vetzuren.jpg"
                                    alt="Omega 3 vetzuren"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Omega 3 vetzuren: waarom zo populair?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        WE ARE – Personal Training Uden en Schijndel komt met
                        een nieuwe blog over omega 3 vetzuren! Omega 3 vetzuren
                        worden steeds populairder. Veel suppletie aanbieders
                        hebben deze vorm van meervoudige onverzadigde vetzuren
                        in hun assortiment en elke leefstijlcoach raad je aan om
                        het te supplementeren. Waarom is deze omega 3 vetzuur zo
                        populair en wat het is eigenlijk?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat zijn omega 3 vetzuren?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Een omega 3 vetzuur is een meervoudige onverzadigde
                        vetzuur. Omdat het een ‘knikje’ in de atoomverbinding
                        zit is het een onverzadigde vetzuur. Wanneer er twee of
                        meer knikjes in deze atoomverbinding zit noemen we het
                        een meervoudige onverzadigde vetzuur. Deze familie
                        vetzuren zijn een belangrijk voor ons lichaam. Ze zijn
                        te verdelen over drie hoofdsoorten:
                    </p>
                    <ul className="mt-4 text-gray-100">
                        <li>Alfa-linoleenzuur (ALA)</li>
                        <li>Eicosapentaeenzuur (EPA)</li>
                        <li>Docosahexaeenzuur (DHA)</li>
                    </ul>
                    <p className="mt-4 text-gray-100 break-words">
                        Alfa-linoleenzuur zit voornamelijk in plantaardige
                        producten en Eicosapentaeenzuur en Docosahexaeenzuur zit
                        in visolie.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Waarom is omega 3 zo belangrijk?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Omega 3 is een belangrijk vetzuur voor groei en
                        ontwikkeling. Daarnaast vermindert het de kans op
                        depressies en angst. Omega 3 ondersteunt ook onze
                        hersenfunctie en de scherpte van ons zicht. Tot slot
                        helpt het ook nog bij de energieproductie van het
                        lichaam en is het een natuurlijke ontstekingsremmer.
                        Kortom is omega 3 een belangrijkste stof in ons fitte en
                        vitale leven.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        De verhoudingen tussen omega 3, 6 en 9 liggen door onze
                        huidige manier van eten niet meer in balans.
                        Wetenschappers zijn het eens dat een verhouding van 1 op
                        6 goed is voor de mens. Waarbij er per zes omega 6
                        vetzuren er één omega 3 vetzuur moet zijn. Deze
                        verhouding ligt anno 2022 op 1 op 15! Door deze
                        verhouding ontstaan er veel ontstekingen in het lichaam
                        die kunnen uitmonden in fysieke en mentale klachten.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe kan ik voldoende omega 3 vetzuren eten?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Omega 3 vetzuren zitten in zowel plantaardige producten
                        als in vis. De voornaamste bron van omega 3 blijft toch
                        vis. Het advies is dan ook om minimaal 2x per week vette
                        vis te eten van de plaatselijke visspecialist.
                        Vissoorten zoals haring en zalm bevatten een hoge
                        hoeveelheid van deze omega 3 vetzuren.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Het kan natuurlijk voorkomen dat je geen vis lust
                        waardoor het lastiger wordt om de juiste hoeveelheid
                        vetzuren per dag te halen. De aanbevolen hoeveelheid
                        ligt op 200 milligram EPA en DHA per dag en 1 gram ALA
                        per 1000 calorieën. In dit geval is het toepassen van
                        suppletie een oplossing om aan voldoende omega 3
                        vetzuren per dag te komen. Daarnaast is het consumeren
                        van plantaardige oliën, zoals walnootolie en lijnzaad en
                        bepaalde zaden en noten die voorzien van
                        Alfa-linoleenzuur belangrijk.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
